export { default as translations } from './translations.json';

/**
 * Calculate insurance premium.
 * @param {number} bookingAmountCents
 * @param {number} ratePct
 * @returns {number}
 */
export const calculatePremium = (bookingAmountCents, ratePct) =>
  Math.round(bookingAmountCents * (ratePct / 100));

/**
 * Get selected insurance from transaction.
 * @param {Object|null} transaction
 * @returns {Object|null}
 */
export const getInsurance = (transaction) =>
  transaction?.attributes?.protectedData?.insurance || null;

export const hasInsurance = (transaction) => !!getInsurance(transaction);
